import { Component, Input, OnInit, TemplateRef } from '@angular/core';

export interface TabConfig {
  id: number;
  title: string;
  content: TemplateRef<any>;
}

@Component({
    selector: 'app-dynamic-tabs',
    templateUrl: './dynamic-tabs.component.html',
    styleUrls: ['./dynamic-tabs.component.css'],
    standalone: false
})
export class DynamicTabsComponent implements OnInit {
  @Input() tabs:  TabConfig[] = [];
  @Input() activeTab = 0;

  constructor() { }

  ngOnInit() {
  }
}